var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"24","height":"24","viewBox":"0 0 25 25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('rect',{attrs:{"x":"0.5","y":"0.5","width":"23","height":"23","rx":"1.5","fill":"white","stroke":"#9898A2"}})])}
var staticRenderFns = []

export { render, staticRenderFns }